import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, {tableCellClasses} from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import RenderMarkdown from '../components/RenderMarkdown'
import {titleStyle} from '../components/text'
import {styled} from '@mui/material/styles'

import type {Example} from '../services/types'

const HeaderCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    ...titleStyle,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.dark,
    border: `2px solid ${theme.palette.primary.main}`,
  },
}))

const StyledTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.body}`]: {
    border: `2px solid ${theme.palette.primary.main}`,
  },
}))

type SampleQuestionsProps = {
  questions: Example[]
  taker: string
}
const SampleQuestions = ({questions, taker}: SampleQuestionsProps) => (
  <TableContainer component={Paper}>
    <Table sx={{minWidth: 650}} aria-label="sample questions">
      <TableHead>
        <TableRow>
          <HeaderCell sx={{fontWeight: 700}}>Question</HeaderCell>
          <HeaderCell align="left" sx={{fontWeight: 700}}>
            Answer from model
          </HeaderCell>
          <HeaderCell align="left" sx={{fontWeight: 700}}>
            True reference answer
          </HeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {questions.map(({id, prompt, response_text, correct_answer}) => (
          <TableRow key={id + prompt}>
            <StyledTableCell component="th" scope="row">
              <RenderMarkdown content={prompt} />
            </StyledTableCell>
            <StyledTableCell align="left">
              <RenderMarkdown content={response_text} />
            </StyledTableCell>
            <StyledTableCell align="left">
              <RenderMarkdown content={correct_answer} />
            </StyledTableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)

export default SampleQuestions
